import classNames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@wix/design-system';
import { AscendBundleHelperKeys } from '../../../constants';
import { PlanType } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import s from './Cycles.scss';

interface AscendBundleHelperProps {
  rootStore: RootStore;
}

const AscendBundleHelperComp: React.FC<AscendBundleHelperProps> = ({
  rootStore,
}) => {
  const { t } = useTranslation();
  const planType: PlanType = rootStore.appStore.currentProduct.type;
  const helperKeysByPlanType: { [key in PlanType]: string[] } = {
    [PlanType.Website]: AscendBundleHelperKeys,
    [PlanType.Business]: [
      ...AscendBundleHelperKeys,
      'subscription_page.ascend_bundle_helper.body_accept.payments',
    ],
    [PlanType.Enterprise]: [],
  };
  return (
    <div className={s.ascendBundle}>
      <Text
        weight='normal'
        size='small'
        dataHook='ascend-helper'
        className={classNames(s.helperTitle)}
      >
        {t('subscription_page.ascend_bundle_helper.title')}
      </Text>
      <div data-hook='ascend-features'>
        {helperKeysByPlanType[planType].map((key, idx) => (
          <div className={s.ascendFeature} key={idx.toString()}>
            <div className={s.checkmark} />
            <Text
              size='small'
              className={s.ascendFeatureText}
              dataHook={`ascend-feature-${idx}`}
            >
              {t(key)}
            </Text>
          </div>
        ))}
      </div>
    </div>
  );
};

export const AscendBundleHelper = withInjectedRootStore(
  observer(AscendBundleHelperComp),
);
